import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiSearch } = FiIcons;

export function SkeletonGrid() {
  return (
    <div className="app-grid">
      {Array.from({ length: 6 }, (_, index) => (
        <div className="skeleton-card" key={index}>
          <span className="skeleton tile" />
          <span className="skeleton title" />
          <span className="skeleton line" />
          <span className="skeleton line short" />
          <div className="skeleton-tags">
            <span className="skeleton" />
            <span className="skeleton" />
          </div>
          <span className="skeleton footer" />
        </div>
      ))}
    </div>
  );
}

export function EmptyState({ onClear }) {
  return (
    <div className="empty-state">
      <SafeIcon icon={FiSearch} />
      <h2>No apps match that</h2>
      <p>Try a different search or clear your filters.</p>
      <button className="secondary-button" type="button" onClick={onClear}>
        Clear all filters
      </button>
    </div>
  );
}